// extracted by mini-css-extract-plugin
module.exports = {"auth":"Auth_styles_auth__2lOXg","authNav":"Auth_styles_authNav__39jig","authContent":"Auth_styles_authContent__3Fqvk","authAside":"Auth_styles_authAside__17J_E"};